import React, { memo } from 'react'
import { Chip } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useFragment } from 'react-relay/hooks'
import { graphql } from 'relay-runtime'
import { QuestionSubheader_Question$key } from '__generated__/QuestionSubheader_Question.graphql'

interface IQuestionSubheaderProps {
  questionFragmentRef: QuestionSubheader_Question$key
}

function QuestionSubheader(props: IQuestionSubheaderProps) {
  const { questionFragmentRef } = props
  const theme = useTheme()
  const chipStyle = { marginRight: theme.spacing(1), marginBottom: theme.spacing(1) }
  const question = useFragment(graphql`
    fragment QuestionSubheader_Question on Question {
      industries {
        id
        name
      }
      specializations {
        id
        name
      }
      skills {
        id
        name
      }
      tags {
        id
        name
      }
    }
  `, questionFragmentRef)

  if (!question) return null

  return (
    <React.Fragment>
      {question.industries?.map(s => <Chip key={s.id} label={s.name} style={chipStyle} />)}
      {question.specializations?.map(s => <Chip key={s.id} label={s.name} style={chipStyle} />)}
      {question.skills?.map(s => <Chip key={s.id} label={s.name} style={chipStyle} />)}
      {question.tags?.map(s => <Chip key={s.id} label={s.name} style={chipStyle} />)}
    </React.Fragment>
  )
}

export default memo(QuestionSubheader)
